import React, { useContext, useEffect, useState } from "react";
import DisplayMessage from "./DisplayMessage";
import { ChatContext } from "../context/ChatContext";
import "../style/Dashboard.scss";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

const Messages = () => {
  const [messages, setMessages] = useState([]);
  const { data } = useContext(ChatContext);

  useEffect(() => {
    const unSub = onSnapshot(doc(db, "chats", data.chatId), (doc) => {
      doc.exists() && setMessages(doc.data().messages);
    });

    return () => {
      unSub();
    };
  }, [data.chatId]);

  return (
    <div className="messages">
      {messages.map((m) => (
        <DisplayMessage message={m} key={m.id} />
      ))}
    </div>
  );
};

export default Messages;
